/**
 * Utilitários para construção de URLs do Firebase Storage
 */

/**
 * Constrói URL pública do Firebase Storage a partir de um caminho
 * @param {string} storagePath - Caminho do arquivo no Storage (ex: "cards/master/machado-de-assis/machado-de-assis_800x800.webp")
 * @returns {string} URL pública do arquivo
 */
export function getStorageUrl(storagePath) {
  const bucket = "memoria-imortais.firebasestorage.app";
  // Encodar o caminho para URL (substituir / por %2F, mas manter outros caracteres)
  const encodedPath = storagePath.split('/').map(segment => encodeURIComponent(segment)).join('%2F');
  return `https://firebasestorage.googleapis.com/v0/b/${bucket}/o/${encodedPath}?alt=media`;
}

/**
 * Constrói URLs do srcset para imagens responsivas a partir de basePath
 * Apenas formato .webp é suportado (sem fallback para outros formatos)
 * @param {string} basePath - BasePath da imagem (ex: "cards/master/machado-de-assis/machado-de-assis")
 * @returns {Object|null} Objeto com src e srcset, ou null se basePath for inválido
 */
export function getStorageImageUrls(basePath) {
  // Validar basePath
  if (!basePath || typeof basePath !== 'string' || basePath.trim() === '') {
    return null;
  }

  // Validar formato do basePath (deve começar com "cards/master/")
  if (!basePath.startsWith('cards/master/')) {
    console.error(`❌ basePath inválido: deve começar com "cards/master/"`, basePath);
    return null;
  }

  // Construir URLs apenas para .webp (formato obrigatório)
  const url800 = getStorageUrl(`${basePath}_800x800.webp`);
  const url1200 = getStorageUrl(`${basePath}_1200x1200.webp`);

  return {
    src: url800,
    srcset: `${url800} 800w, ${url1200} 1200w`,
    sizes: '(max-width: 768px) 800px, 1200px'
  };
}
